import React, { useState, useEffect } from "react";
import moment from "moment";
import "./Home.css";
import instance from "../../config/axios";
import Card from "../../components/Card/Card";

function Home() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  let dateNow = moment(new Date()).format("DD MMMM YYYY HH:mm:ss");
  let today = moment().locale("idr").format("dddd");
  let sec = 300;
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await instance.get("/api/live/tv/now");
        setData(res.data);
        setLoading(false);
      } catch (error) {
        // console.log(error);
        setLoading(false);
      }
    };
    fetchData();

    const timer = setInterval(() => {
      setLoading(true);
      fetchData();
    }, sec * 1000);

    return () => {
      clearInterval(timer);
    };
  }, [setLoading, sec]);

  return (
    <div className="home-container">
      <div className="home-header">
        <div className="source-logo">
          <img src="./assets/logo-vidio.png" alt="" width="150px" />
        </div>
        <div className="home-date">
          <span>
            Last Updated {today}, {dateNow}
          </span>
          <img src="./assets/red.gif" alt="" width="70px" />
        </div>
      </div>
      <Card loading={loading} data={data} />
    </div>
  );
}

export default Home;
